app.controller("ProgramsIndexController", ["$scope", "$q", "ProgramService", "$stateParams", "StaticData", "ConfirmModal", "$uibModal", "$state", "usSpinnerService", "toastr",
    function ($scope, $q, ProgramService, $stateParams, StaticData, ConfirmModal, $uibModal, $state, usSpinnerService, toastr) {
        $scope.programs = [];
        $scope.itemsPerPage = 25;
        $scope.query = $stateParams.query;
        $scope.selectionState = $stateParams.selectionState;
        $scope.selectionStates = [{name:'არჩევითობის სტატუსი'}, {name: 'აქტიური', value: true}, {name: 'არააქტიური', value: false}];
        $scope.selectedLevels = [];
        $scope.selectedFaculties = [];

        function fillFilterFields() {
            if ($stateParams.faculty) {
                var faculty = $stateParams.faculty;
                faculty = typeof faculty === 'string' ? [faculty] : faculty;
                $scope.selectedFaculties = $scope.faculties.filter(function (f) {
                    return faculty.indexOf(f._id) > -1
                });
            }

            if ($stateParams.level) {
                var level = $stateParams.level;
                level = typeof level === 'string' ? [level] : level;
                $scope.selectedLevels = $scope.levels.filter(function (l) {
                    return level.indexOf(l._id) > -1
                });
            }
        }

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            ProgramService.list({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                faculty: $stateParams.faculty,
                level: $stateParams.level,
                selectionState: $scope.selectionState
            }).then(function (data) {
                $scope.programs = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $q.all([
            StaticData.getItemsByKey("faculties"),
            StaticData.getItemsByKey("levels"),
        ]).then(function (results) {
            var faculties = results[0];
            var levels = results[1];

            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');

            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');

            fillFilterFields();
        });

        $scope.addFacultyToFilter = function () {
            if ($scope.selectedFaculties.map(function(fac){return fac._id}).indexOf($scope.faculty) > -1) return;
            $scope.selectedFaculties.push($scope.faculties.find(function (f) {
                return f._id === $scope.faculty
            }));
            $scope.faculty = $scope.faculties[0]._id;
            $scope.applyFilter();
        };

        $scope.removeFaculty = function (fac) {
            $scope.selectedFaculties = $scope.selectedFaculties.filter(function (f) {
                return f !== fac
            });
            $scope.applyFilter();
        }

        $scope.addLevelToFilter = function () {
            if ($scope.selectedLevels.map(function(s){return s._id}).indexOf($scope.level) > -1) return;
            $scope.selectedLevels.push($scope.levels.find(function (s) {
                return s._id === $scope.level
            }));
            $scope.level = $scope.levels[0]._id;
            $scope.applyFilter();
        };

        $scope.removeLevel = function (lev) {
            $scope.selectedLevels = $scope.selectedLevels.filter(function (l) {
                return l !== lev
            });
            $scope.applyFilter();
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.selectedFaculties.length ? $scope.selectedFaculties.map(function (f) {
                    return f._id;
                }) : undefined,
                level: $scope.selectedLevels.length ? $scope.selectedLevels.map(function (l) {
                    return l._id;
                }) : undefined,
                selectionState: $scope.selectionState
            });
        };

        $scope.copyProgram = function (program, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "CopyProgramController",
                templateUrl: _pb + 'admin/programs/copy-program.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            program: {_id: program._id, code: program.code}
                        };
                    }
                }
            }).result.then(function () {
                loadPage($scope.currentPage);
            }, function () {
            });
        };

        $scope.editProgram = function (programId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditProgramPropertiesController",
                templateUrl: _pb + 'admin/programs/edit-program-properties.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            programId: programId
                        };
                    }
                }
            }).result
                .then(function () {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.deleteProgram = function (program, $event) {
            var programId = program._id;
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "პროგრამის წაშლა",
                message: "თქვენ შლით პროგრამას - " + program.name + ". გსურთ პროგრამის წაშლა ?"
            }).result.then(function () {
                ProgramService.removeProgram(programId).then(function (res) {
                    if(res === 'Active student!') toastr.error('პროგრამაზე დარეგისტრირებულია აქტიური სტატუსის მქონე სტუდენტი')
                    else loadPage($scope.currentPage)
                })
            });
        };

        $scope.blockProgram = function (program, $event) {
            var programId = program._id;
            var action = !program.readOnly;

            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "პროგრამის დაბლოკვა",
                message: "თქვენ ბლოკავთ პროგრამას - " + program.name + ". გსურთ პროგრამის დაბლოკვა ?"
            }).result.then(function () {
                ProgramService.blockProgram(programId, action).then(
                    loadPage($scope.currentPage)
                )
            });
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddProgramController",
                templateUrl: _pb + 'admin/programs/add-program.html',
                size: "md"
            }).result
                .then(function () {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.edit = function (programId) {
            $state.go("admin.edit-program", {programId: programId});
        }
    }
]);
